import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../../store';
import {
  Button,
  ButtonSet,
  Container,
  Grid,
  GridColumn,
  ModalTitle,
  ModalSubtitle,
  PanelSection,
  Panel,
  PanelSectionGroup,
} from '../../../core/components/styled';
import DocumentListTableRow from '../forms/DocumentListTableRow';
import { Modal, Table } from '../../../core/components';
import translate from '../../../core/services/translate';

interface Props {
  closeModal: () => void;
}

const DocumentListModal: React.FC<Props> = ({ closeModal }) => {
  const fileDetails = useSelector((state: AppState) => state.fleet.workOrderDocuments.documents);
  const isExporting = useSelector((state: AppState) => state.fleet.serviceConfirmation.isExporting);
  const documentListTableCells = [{ name: 'fileName', label: translate('autoDispatch.fileName'), width: '100%' }];
  return (
    <Modal size="small">
      <ModalTitle>{translate('autoDispatch.fileDetail')}</ModalTitle>
      <ModalSubtitle />
      <Grid centered>
        <GridColumn size="12/12">
          <Panel>
            <PanelSection vertical centered padding="small" isLoading={isExporting}>
              <Container>
                <Panel margin="no no xLarge">
                  <PanelSectionGroup>
                    <PanelSection vertical>
                      {!!fileDetails && (
                        <Table cells={documentListTableCells} rows={fileDetails} rowComponent={DocumentListTableRow} />
                      )}
                    </PanelSection>
                  </PanelSectionGroup>
                </Panel>
              </Container>
              <Container>
                <ButtonSet margin="medium small small">
                  <Button type="button" color="secondary" onClick={() => closeModal()}>
                    {translate('autoDispatch.close')}
                  </Button>
                </ButtonSet>
              </Container>
            </PanelSection>
          </Panel>
        </GridColumn>
      </Grid>
    </Modal>
  );
};

export default DocumentListModal;
